/**
 * Iconos de las consultas sugeridas.
 *
 * El backend las envía con nombres de FontAwesome (panel anterior); aquí se
 * traducen a lucide para la web nueva, con un icono por defecto.
 */

import {
  Boxes,
  ChartLine,
  ClipboardList,
  Clock,
  Droplets,
  FileText,
  Fuel,
  PackageSearch,
  Sparkles,
  Tags,
  Target,
  TrendingUp,
  TriangleAlert,
  Truck,
  Users,
  Warehouse,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  'fa-chart-line': ChartLine,
  'fa-chart-pie': ChartLine,
  'fa-gas-pump': Fuel,
  'fa-clock': Clock,
  'fa-tint': Droplets,
  'fa-triangle-exclamation': TriangleAlert,
  'fa-circle-exclamation': TriangleAlert,
  'fa-file-invoice-dollar': FileText,
  'fa-money-bill-trend-up': TrendingUp,
  'fa-users': Users,
  // Módulos incorporados al asistente (inventario, compras, precios, metas,
  // mantenimiento y reportes).
  'fa-boxes-stacked': Boxes,
  'fa-warehouse': Warehouse,
  'fa-tags': Tags,
  'fa-bullseye': Target,
  'fa-clipboard-list': ClipboardList,
  'fa-screwdriver-wrench': Wrench,
  'fa-truck-field': Truck,
  'fa-magnifying-glass-dollar': PackageSearch,
};

export function resolveSuggestionIcon(icono: string | null | undefined): LucideIcon {
  if (!icono) return Sparkles;

  return ICONS[icono.trim().toLowerCase()] ?? Sparkles;
}
